import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

const initialState={
    pcategoriesList:[],
    scategoryiesList:[],
    selectedCategory: null,
    SselectedCategory: null,
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    status:"idle",
    pcategoriesStatus: "idle",
    scategoriesStatus: "idle",
    selectedCategoryStatus: "idle",
    error:''
}

export const fetchPcategories=createAsyncThunk('categories/fetchcCategories', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/category/getCategories',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})
export const fetchScategories=createAsyncThunk('categories/fetchcSCategories', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/category/getCategoriesSummary',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})
export const fetchcategoriesById=createAsyncThunk('categories/fetchcCategoriesByID', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/category/getCategoriesbyId/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchScategoriesById=createAsyncThunk('categories/fetchcSCategoriesByID', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/category/getCategoriesSummaryById/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const createCategory=createAsyncThunk('categories/createCategory', async (categoryData)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/category/addCategory',
        {
            method: 'POST',
            body: JSON.stringify(categoryData),
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }

        }
    )
    return response.json()
})

export const updateCategory=createAsyncThunk('categories/updateCategory', async ({categoryData,cid})=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/category/updateCategory/${cid}`,
        {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(categoryData)
        }
    )
    return response.json()
})

export const deleteCategory=createAsyncThunk('categories/deleteCategory', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/category/deleteCategory/${id}`,
        {
            method: 'GET',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

const categorySlice =createSlice({
    name: "pcategories",
    initialState,
    reducers: {
        changeRegisterStatus: (state) => {
            state.registerstatus = 'failure';
        },
        changeEditStatus: (state) => {
            state.editstatus = 'failure';
        },
        changeDeleteStatus: (state) => {
            state.deletestatus = 'failure';
        },
    },
    extraReducers: (builder) => {

        builder
            .addCase(fetchPcategories.pending, (state, action) => {
                state.pcategoriesStatus = 'loading';
            })
            .addCase(fetchPcategories.fulfilled, (state, action) => {
                state.pcategoriesStatus = 'success';
                //state.eventsList = state.eventsList.concat(action.payload);
                state.pcategoriesList = action.payload;
            })
            .addCase(fetchPcategories.rejected, (state, action) => {
                state.pcategoriesStatus = 'error';
                state.error = state.error.message || 'Failed to fetch pcategories';
            })
            .addCase(fetchScategories.pending, (state, action) => {
                state.scategoriesStatus = 'loading';
            })
            .addCase(fetchScategories.fulfilled, (state, action) => {
                state.scategoriesStatus = 'success';
                //state.eventsList = state.eventsList.concat(action.payload);
                state.scategoryiesList = action.payload;
            })
            .addCase(fetchScategories.rejected, (state, action) => {
                state.scategoriesStatus = 'error';
                state.error = state.error.message || 'Failed to fetch pcategories';
            })
            .addCase(fetchcategoriesById.pending, (state, action) => {
                state.selectedCategoryStatus = 'loading';
            })
            .addCase(fetchcategoriesById.fulfilled, (state, action) => {
                state.selectedCategoryStatus = 'success';
                //state.eventsList = state.eventsList.concat(action.payload);
                state.selectedCategory = action.payload;
            })
            .addCase(fetchcategoriesById.rejected, (state, action) => {
                state.selectedCategoryStatus = 'error';
                state.error = state.error.message || 'Failed to fetch pcategories';
            })
            .addCase(fetchScategoriesById.pending, (state, action) => {
                state.status = 'loading';
            })
            .addCase(fetchScategoriesById.fulfilled, (state, action) => {
                state.status = 'success';
                //state.eventsList = state.eventsList.concat(action.payload);
                state.SselectedCategory = action.payload;
            })
            .addCase(fetchScategoriesById.rejected, (state, action) => {
                state.status = 'error';
                state.error = state.error.message || 'Failed to fetch pcategories';
            })
                .addCase(createCategory.pending, (state, action) => {
                    state.registerstatus = 'loading';
                })
                .addCase(createCategory.fulfilled, (state, action) => {
                    state.registerstatus = 'success';
                })
                .addCase(createCategory.rejected, (state, action) => {
                    state.registerstatus = 'failure';
                    state.error = state.error.message || 'Failed to create category';
                })
                .addCase(updateCategory.pending, (state, action) => {
                    state.editstatus = 'loading';
                })
                .addCase(updateCategory.fulfilled, (state, action) => {
                    state.editstatus = 'success';
                })
                .addCase(updateCategory.rejected, (state, action) => {
                    state.editstatus = 'failure';
                    state.error = state.error.message || 'Failed to update category';
                })
                .addCase(deleteCategory.pending, (state, action) => {
                    state.deletestatus = 'loading';
                })
                .addCase(deleteCategory.fulfilled, (state, action) => {
                    state.deletestatus = 'success';
                })
                .addCase(deleteCategory.rejected, (state, action) => {
                    state.deletestatus = 'failure';
                    state.error = state.error.message || 'Failed to delete category';
                })
    }
})

export default categorySlice.reducer;